import { callOnce } from './utils/initialize';
import { setTimezoneInCookies } from './utils/timezone';
import * as Sentry from '@sentry/browser';
import { envName } from './env';

import { fullStoryIntegration } from '@sentry/fullstory';

const appInitialize = () => {
  setTimezoneInCookies();
  if (
    window.cookieyes &&
    window.getCkyConsent &&
    window.getCkyConsent().categories.analytics
  ) {
    const fsClient = window.FS;

    Sentry.init({
      dsn:
        'https://6c8bb0d4ced34f0c912aa6495892277f@o932187.ingest.sentry.io/5986660',
      integrations: [
        Sentry.browserTracingIntegration(),
        ...(fsClient
          ? [fullStoryIntegration('bidx1', { client: fsClient })]
          : []),
      ],
      tracesSampleRate: 0.5,
      environment: envName,
    });
  }
};

callOnce(appInitialize);
